import styled from "styled-components"
import { selectIsCreateTeamModalOpen } from "features/common/model/selectors/appSelectors"
import { setIsCreateTeamModalOpen } from "features/common/model/slice/appSlice"
import { useAppDispatch, useAppSelector } from "shared/config/store"
import { Button, Form, FormProps, Input, Modal, Typography } from "shared/ui"
import { userSelector } from "features/user/model/selectors/userSelectors"
import { fetchUserDataThunk, updateUserDataThunk } from "features/user/model/slice/userSlice"

import { createFamilyCloudThunk } from "../model/slice/teamSlice"

const { Title } = Typography

type FieldType = {
  name: string
}

export const CreateTeamModal = () => {
  const dispatch = useAppDispatch()
  const isCreateTeamModalOpen = useAppSelector(selectIsCreateTeamModalOpen)

  const userData = useAppSelector(userSelector)

  const handleClose = () => {
    dispatch(setIsCreateTeamModalOpen(false))
  }

  const handleFinish: FormProps<FieldType>['onFinish'] = (values) => {
    const callback = (familyUserId: number, ownerId: number) => {
      dispatch(updateUserDataThunk({ family_user_id: familyUserId, is_owner_family: userData?.id === ownerId }))
    }

    dispatch(createFamilyCloudThunk({ data: values, callback }))
    dispatch(fetchUserDataThunk())
    handleClose()
  }
  
  const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Modal open={isCreateTeamModalOpen}
      footer={null}
      width={480}      
      closable={false}
      destroyOnClose={true}
    >
      <SModalTitle>
        <Title>
          Create team
        </Title>
      </SModalTitle>

      <SContentContainer>
        <Form layout="vertical"
          onFinish={handleFinish}
          onFinishFailed={onFinishFailed}
          preserve={false}
          requiredMark="optional"
        >
          <Form.Item name="name"
            label="Create team"
            rules={[{ required: true, message: "Enter team name" }]}
          >
            <Input size="large"
              placeholder="Enter team name"
            />
          </Form.Item>

          <Form.Item>
            <Button block
              type="primary"
              htmlType="submit"
            >
              Create
            </Button>
          </Form.Item>
        </Form>
      </SContentContainer>
    </Modal>
  )
}

const SContentContainer = styled.div``

const SModalTitle = styled.div`
  text-align: center
`

